export default __webpack_public_path__ + "static/media/calendar-cancelled.94ccfb9f.svg";